import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";

declare var mixpanel;

type HotjarCommand = (command: string, ...args: unknown[]) => void;

@Injectable()
export class ProductAnalyticService {

  MPE_RFQ_CREATION_INITIATED = "rfqCreationInitiated";
  MPE_RFQ_DONE_WITH_PARTS = "rfqDoneWithParts";
  MPE_RFQ_DETAILS_ADDED = "rfqDetailsAdded";
  MPE_RFQ_SHIPPING_ADDED = "rfqShippingAdded";
  MPE_RFQ_SUBMITTED = "rfqSubmitted";

  MPE_RFQ_UPLOAD_DRAWING_FILE_IGNORED = "rfqUploadDrawingFileIgnored";
  MPE_RFQ_UPLOAD_DRAWING_FILE_CLICKED = "rfqUploadDrawingFileClicked";
  MPE_UPLOAD_DRAWING_FILE_COMPLETED = "uploadDrawingFileCompleted";
  MPE_BUYER_ONBOARD_WELCOME = "buyer onboard welcome";
  MPE_BUYER_ONBOARD_FIRST_PART = "buyer onboard first-part";
  MPE_BUYER_ONBOARD_NO_PART = "buyer onboard no-part";
  MPE_BUYER_COMPANY_PROFILE = "buyer company profile";
  MPE_BUYER_BUYER_ONBOARD_INDUSTRY = "buyer onboard industry";
  MPE_BUYER_BUYER_RFQ_COMPLETED = "buyer rfq completed";
  MPE_PAGEVIEW = "pageview";
  MPE_MESSAGE_SENT = "message sent";
  MPE_BUYER_RFQ_CANCELLED = "buyer rfq cancelled";
  MPE_RFQ_FORM_START = "rfq form start";
  MPE_RFQ_PARTS = "rfq parts";
  MPE_RFQ_DETAILS = "rfq details";
  MPE_RFQ_DRAFT = "rfq Draft";
  MPE_RFQ_FORM_SUBMIT = "rfq form submit";
  MPE_BUYER_RFQ_AWARDED = "buyer rfq awarded";
  MPE_MESSAG = "messag";
  MPE_BUYER_PARTS_RECIEVED = "buyer parts recieved";
  MPE_ALC_Unlock_Button = "ALC-Unlock Button";
  MPE_ALC_PURCHASE_NOW_BUTTON = "ALC-Purchase Now button";
  MPE_ALC_PURCHASE_SUCCESS = "ALC-Purchase Success";
  MPE_LOGIN = "login";
  MPE_LAND_ON_DASHBOARD = "land on dashboard";

  MPE_SUPPLIER_RFQ_MARKETPLACE = "supplier rfq marketplace";
  MPE_SUPPLIER_RFQ_DETAILS_PAGE = "supplier rfq detail";
  MPE_SUPPLIER_SUBMIT_QUOTE = "supplier quote submitted";
  MPE_SUPPLIER_RFQ_UNLOCKED = "supplier rfq unlocked";

  MPE_SUPPLIER_QUOTE_ASSIST_CLICKED = "supplier quote assist clicked";
  MPE_SUPPLIER_QUOTE_ASSIST_OPEN = "supplier quote assist open";
  MPE_SUPPLIER_QUOTE_ASSIST_SAVE_TO_DRAFT = "supplier quote assist save to draft";
  MPE_SUPPLIER_QUOTE_ASSIST_SKIPPED_TO_QUOTE = "supplier quote assist skip to quote";
  MPE_SUPPLIER_QUOTE_ASSIST_CLOSED = "supplier quote assist closed";
  MPE_SUPPLIER_QUOTE_ASSIST_CREATE_QUOTE = "supplier quote assist create quote";
  MPE_SUPPLIER_QUOTE_ASSIST_LANDED_ON_QUOTE_SUMMARY = "supplier quote assist landed on quote summary";
  MPE_SUPPLIER_QUOTE_ASSIST_REVIEW_QUOTE = "supplier quote assist review quote";

  MPE_SUPPLIER_DASHBOARD_PUBLISH_PROFILE_UPGRADE_CLICKED = "supplier dashboard publish profile upgrade clicked";
  MPE_SUPPLIER_PROFILE_PUBLISH_PROFILE_UPGRADE_CLICKED = "supplier profile publish profile upgrade clicked";

  MPE_WEBSITE_LAUNCH_BUTTON_CLICKED = "Website Builder - Launch Button Clicked";

  MPE_BUYER_QUOTE_INTELLIGENCE_CLICKED = "BuyerQuoteIntelligenceClicked";
  MPE_SUPPLIER_QUOTE_INTELLIGENCE_CLICKED = "SupplierQuoteIntelligenceClicked";

  MPE_BUYER_RFQ_QI_PART_CHANGED = "QuoteIntelligenceBuyerPartChanged";
  MPE_BUYER_RFQ_QI_PART_EDITED = "QuoteIntelligenceBuyerPartEdited";
  MPE_BUYER_RFQ_QI_DONE_WITH_INTELLIGENCE = "QuoteIntelligenceBuyerDoneWithIntelligence";
  MPE_BUYER_RFQ_QI_BACK_TO_RFQ_DETAILS = "QuoteIntelligenceBuyerBackToRfqDetails";
  MPE_BUYER_RFQ_QI_READ_DURATION = "QuoteIntelligenceBuyerTotalReadDuration";
  MPE_BUYER_RFQ_QI_OPTIMIZATIONS_CLICKED = "QuoteIntelligenceBuyerOptimizationsClicked";
  MPE_BUYER_RFQ_QI_FORECAST_CLICKED = "QuoteIntelligenceBuyerForecastClicked";
  MPE_BUYER_RFQ_QI_RISK_FLAGS_CLICKED = "QuoteIntelligenceBuyerRiskFlagsClicked";
  MPE_BUYER_RFQ_QI_DATA_BACKED_CLICKED = "QuoteIntelligenceBuyerDataBackedClicked";
  MPE_QUOTES_V2_RFQ_PAGE_VIEWED = "Buyer QuotesV2 RFQ Page Viewed";
  MPE_QUOTES_V2_PRIORITY_CHANGED = "Buyer QuotesV2 Priority Changed";
  MPE_QUOTES_V2_LIST_FILTER_CHANGED = "Buyer QuotesV2 List Filter Changed";
  MPE_QUOTES_V2_COMPARE_CLICKED = "Buyer QuotesV2 Supplier Card Compare Clicked";
  MPE_QUOTES_V2_COMPARE_MODAL_OPENED = "Buyer QuotesV2 Compare Modal Opened";
  MPE_QUOTES_V2_CHAT_OPENED = "Buyer QuotesV2 Supplier Card Message Clicked";
  MPE_QUOTES_V2_SUMMARY_REVIEW_DRAFT_CLICKED = "Buyer QuotesV2 Summary Review Message Draft  Clicked";
  MPE_QUOTES_V2_SUPPLIER_CARD_REVIEW_DRAFT_CLICKED = "Buyer QuotesV2 Supplier Card Review Message Draft Clicked";
  MPE_QUOTES_V2_SUPPLIER_PROFILE_OPENED = "Buyer QuotesV2 Supplier Profile Opened";
  MPE_QUOTES_V2_SUPPLIER_NOTE_OPENED = "Buyer QuotesV2 Supplier Note Opened";
  MPE_QUOTES_V2_REJECT_CLICKED = "Buyer QuotesV2 Supplier Card Reject Clicked";
  MPE_QUOTES_V2_SUMMARY_REJECT_CLICKED = "Buyer QuotesV2 Quick Action Reject Clicked";
  MPE_QUOTES_V2_CONFIRM_REJECT = "Buyer QuotesV2 Confirm Reject";
  MPE_QUOTES_V2_AWARD_CLICKED = "Buyer QuotesV2 Supplier Card Award Clicked";
  MPE_QUOTES_V2_CONTINUE_TO_AWARD = "Buyer QuotesV2 Continue to Award";
  MPE_QUOTES_V2_AWARD_COMPLETED = "Buyer QuotesV2 Award Completed";
  EDIT_RFQ = "EDIT_RFQ";
  /** UserGuiding `appPage` while the buyer onboarding popup is open (keeps RFQ guides from firing). */
  BUYER_ONBOARDING = "BUYER_ONBOARDING";
  GROWTH_PACKAGE = "GROWTH_PACKAGE";
  ECOMMERCE = "ECOMMERCE";
  QUOTES_RFQ_LIST = "QUOTES_RFQ_LIST";
  QUOTES_V2 = "QUOTES_V2";
  /** UserGuiding `appPage` for supplier network landing (`/supplier-network-dasboard`). */
  SUPPLIER_NETWORK_DASHBOARD = "SUPPLIER_NETWORK_DASHBOARD";
  BASIC_LOGIN = "BASIC_LOGIN";
  BASIC_LOGIN2 = "BASIC_LOGIN2";
  ADMIN = "ADMIN";
  DEFAULT = "DEFAULT";

  static readonly SESSION_BUYER_ONBOARDING_ACTIVE = 'buyerOnboardingActive';
  static readonly SESSION_BUYER_ONBOARDING_JUST_COMPLETED = 'buyerOnboardingJustCompleted';
  closeAnalyticSession() {
    if (this.isMixpanelInitialized()) {
      if (mixpanel?.reset) {
        mixpanel.reset();
      }
    }
    this.hotjarClearUser();
  }

  private getHotjarApi(): HotjarCommand | undefined {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const api = (window as Window & { hj?: HotjarCommand }).hj;
    return typeof api === 'function' ? api : undefined;
  }

  private hotjarInvoke(command: string, ...args: unknown[]): void {
    this.getHotjarApi()?.(command, ...args);
  }

  /** Call after login when user profile is available. Requires Hotjar snippet in index.html. */
  hotjarIdentifyUser(): void {
    if (AppStorageUtil.getItem('isLoginFromVision') === 'true') {
      return;
    }
    if (!this.getHotjarApi()) {
      return;
    }
    const submitModel = JSON.parse(AppStorageUtil.getItem('iContactViewModel'));
    if (!submitModel) {
      return;
    }
    const userType = AppStorageUtil.getLoogedUserType();
    let loggedInUserId = '' + AppStorageUtil.getLoogedUserId();
    if (!environment.production) {
      loggedInUserId = environment.environmentName.toUpperCase() + '_' + loggedInUserId;
    }
    this.hotjarInvoke('identify', loggedInUserId, {
      email: AppStorageUtil.getLoogedUserEmail(),
      user_type: userType,
      role: userType,
      company_id: AppStorageUtil.getCommpanyId(),
      first_name: submitModel.firstName,
      last_name: submitModel.lastName,
      env: environment.environmentName,
    });
  }

  hotjarClearUser(): void {
    if (!this.getHotjarApi()) {
      return;
    }
    this.hotjarInvoke('identify', null, {});
  }

  /** Notify Hotjar of SPA route changes for URL-based session targeting. */
  hotjarStateChange(relativeUrl: string): void {
    if (!this.getHotjarApi() || !relativeUrl) {
      return;
    }
    this.hotjarInvoke('stateChange', relativeUrl);
  }

  mixpanelTracking(eventName, data: any = {}) {
    if (AppStorageUtil.getItem("isLoginFromVision") === 'true') {
      return false;
    }
    if (!mixpanel) {
      return;
    }
    const submitModel = JSON.parse(AppStorageUtil.getItem('iContactViewModel'));
    if (!submitModel) {
      this.mixpanelTrackPageView();
      return;
    }
    let loggedInUserId = "" + AppStorageUtil.getLoogedUserId();
    if (!environment.production) {
      loggedInUserId = environment.environmentName.toUpperCase() + "_" + loggedInUserId;
    }
    if (AppStorageUtil.getMixpanelIdentification() != AppStorageUtil.getLoogedUserId()) {
      if (this.isMixpanelInitialized()) {
        mixpanel.identify(loggedInUserId);
        mixpanel.people.set({
          "$email": AppStorageUtil.getLoogedUserEmail(),
          "$phone": submitModel.phoneNo,
          "$first_name": submitModel.firstName,
          "$last_name": submitModel.lastName,
          "$user_id": loggedInUserId,
          "$distinct_id": loggedInUserId,
        });
      }
      AppStorageUtil.setMixpanelIdentification();
    }
    this.hotjarIdentifyUser();

    if (!environment.production) {
      data.env = environment.environmentName;
    }
    data = Object.assign(data,
      {
        event: eventName,
        email: AppStorageUtil.getLoogedUserEmail(),
        user_id: loggedInUserId,
        role: AppStorageUtil.getLoogedUserType(),
        first_name: submitModel.firstName,
        last_name: submitModel.lastName,
        phone: submitModel.phoneNo,
        zip: submitModel.postalCode,
        distinct_id: loggedInUserId,
        "$email": AppStorageUtil.getLoogedUserEmail(),
        "$user_id": loggedInUserId,
        "$distinct_id": loggedInUserId,
        companyId: AppStorageUtil.getCommpanyId()
      });

    switch (AppStorageUtil.getLoogedUserType()) {
      case "Buyer":
        data.validated_buyer = submitModel.isValidatedBuyer,
          data.rfq_count = AppStorageUtil.getItem('submitRfqCount')
        break;
      case "Supplier":
        data['selected_country'] = AppStorageUtil.getInObj(AppStorageUtil.getJSON('iContactViewModel'), 'country') || '';
        data['selected_state'] = AppStorageUtil.getInObj(AppStorageUtil.getJSON('iContactViewModel'), 'state') || '';
        break;
    }

    if (!environment.production) { }

    if (eventName == this.MPE_PAGEVIEW) {
      this.mixpanelTrackPageView();
      return;
    }
    this.mixpanelTrackEvent(eventName, data);
  }

  mixpanelTrackPageView(retryCount = 0) {
    if (this.isMixpanelInitialized()) {
      mixpanel.track_pageview();
    } else if (retryCount < 3) {
      setTimeout(() => {
        this.mixpanelTrackPageView(retryCount + 1);
      }, 1000);
    }
    // If retryCount >= 3, silently fail
  }

  mixpanelTrackEvent(eventName: string, data: any = {}, retryCount = 0) {

    if (this.isMixpanelInitialized()) {
      mixpanel.track(eventName, data);
    } else if (retryCount < 3) {
      setTimeout(() => {
        this.mixpanelTrackEvent(eventName, data, retryCount + 1);
      }, 1000);
    }
    // If retryCount >= 3, silently fail
  }

  isMixpanelInitialized() {
    return typeof mixpanel !== 'undefined' && typeof mixpanel !== null && typeof mixpanel.track === 'function';
  }

  isBuyerOnboardingActive(): boolean {
    return AppStorageUtil.getSessionItem(ProductAnalyticService.SESSION_BUYER_ONBOARDING_ACTIVE) === 'true';
  }

  setBuyerOnboardingActive(active: boolean): void {
    AppStorageUtil.setSessionItem(
      ProductAnalyticService.SESSION_BUYER_ONBOARDING_ACTIVE,
      active ? 'true' : 'false'
    );
  }

  markBuyerOnboardingJustCompleted(): void {
    AppStorageUtil.setSessionItem(ProductAnalyticService.SESSION_BUYER_ONBOARDING_JUST_COMPLETED, 'true');
  }

  consumeBuyerOnboardingJustCompleted(): boolean {
    const justCompleted =
      AppStorageUtil.getSessionItem(ProductAnalyticService.SESSION_BUYER_ONBOARDING_JUST_COMPLETED) === 'true';
    if (justCompleted) {
      AppStorageUtil.setSessionItem(ProductAnalyticService.SESSION_BUYER_ONBOARDING_JUST_COMPLETED, 'false');
    }
    return justCompleted;
  }

  initializeUserGuiding(pageName: string, visitor = {}, account = {}, rfqCount?: number) {

    const iContactViewModel = JSON.parse(AppStorageUtil.getItem('iContactViewModel'));
    if (AppStorageUtil.getItem("isLoginFromVision") === 'true') {
      return false;
    }

    if (!iContactViewModel) {
      console.log("iContactViewModel is undefined, skipping UserGuiding initialization.");
      return;
    };

    // Do not fire RFQ-creation guides while the buyer onboarding popup is open.
    if (pageName === this.EDIT_RFQ && this.isBuyerOnboardingActive()) {
      console.log('Skipping UserGuiding EDIT_RFQ identify while buyer onboarding is active.');
      return;
    }

    if (typeof (window as any).userGuiding === 'undefined' || typeof (window as any).userGuiding.identify !== 'function') {
      console.log('UserGuiding SDK not available, skipping identify.');
      return;
    }

    const profileComplete = AppStorageUtil.getItem('profileComplete');
    const accountType = AppStorageUtil.getItem("AccountType");
    const userType = AppStorageUtil.getItem("Usertype");
    const landedOnPlanPage = AppStorageUtil.getItem("landedOnPlanPage");
    let visitorId = iContactViewModel.contactId;
    const userRegistered = iContactViewModel.createdOn;
    if (environment.environmentName != "PROD") {
      visitorId = environment.environmentName + "_" + visitorId;
    }

    if (userType === "Buyer") {
      console.log(visitorId.toString() + ' userguiding identify start - buyer');

      (window as any).userGuiding.identify
        (visitorId,
          {
            userRegistered: userRegistered !== undefined && userRegistered !== null ? new Date(userRegistered).toISOString().split('T')[0] : '-',
            companyId: iContactViewModel.companyId !== undefined && iContactViewModel.companyId !== null ? iContactViewModel.companyId : '-',
            companyName: iContactViewModel.company.name !== undefined && iContactViewModel.company.name !== null ? iContactViewModel.company.name : '-',
            role: userType !== undefined && userType !== null ? userType : '-',
            email: iContactViewModel.accountEmail !== undefined && iContactViewModel.accountEmail !== null ? iContactViewModel.accountEmail : '-',
            firstName: iContactViewModel.firstName !== undefined && iContactViewModel.firstName !== null ? iContactViewModel.firstName : '-',
            lastName: iContactViewModel.lastName !== undefined && iContactViewModel.lastName !== null ? iContactViewModel.lastName : '-',
            verifiedEmail: iContactViewModel.isEmailVerified !== undefined && iContactViewModel.isEmailVerified !== null ? iContactViewModel.isEmailVerified : '-',
            manufacturingLocation: '-',
            numberOfEmployees: '-',
            profileComplete: '-',
            landedOnPlanPage: '-',
            noOfRfqCreated: rfqCount !== undefined && rfqCount !== null ? rfqCount : '-',
            planLevel: '-',
            appPage: pageName,
            buyerOnboardingActive: this.isBuyerOnboardingActive()
          }
        );
      console.log(visitorId.toString() + ' userguiding identify end - buyer');
    }

    if (userType === "Supplier") {
      console.log(visitorId.toString() + ' userguiding identify start - supplier');

      (window as any).userGuiding.identify
        (visitorId,
          {
            userRegistered: userRegistered !== undefined && userRegistered !== null ? new Date(userRegistered).toISOString().split('T')[0] : '-',
            companyId: iContactViewModel.companyId !== undefined && iContactViewModel.companyId !== null ? iContactViewModel.companyId : '-',
            companyName: iContactViewModel.company.name !== undefined && iContactViewModel.company.name !== null ? iContactViewModel.company.name : '-',
            role: userType !== undefined && userType !== null ? userType : '-',
            email: iContactViewModel.accountEmail !== undefined && iContactViewModel.accountEmail !== null ? iContactViewModel.accountEmail : '-',
            firstName: iContactViewModel.firstName !== undefined && iContactViewModel.firstName !== null ? iContactViewModel.firstName : '-',
            lastName: iContactViewModel.lastName !== undefined && iContactViewModel.lastName !== null ? iContactViewModel.lastName : '-',
            verifiedEmail: iContactViewModel.isEmailVerified !== undefined && iContactViewModel.isEmailVerified !== null ? iContactViewModel.isEmailVerified : '-',
            manufacturingLocation: iContactViewModel.buyerLocation !== undefined && iContactViewModel.buyerLocation !== null ? iContactViewModel.buyerLocation : '-',
            numberOfEmployees: iContactViewModel.company.employeeCountRange !== undefined && iContactViewModel.company.employeeCountRange !== null ? iContactViewModel.company.employeeCountRange : '-',
            profileComplete: profileComplete !== undefined && profileComplete !== null ? profileComplete : '-',
            landedOnPlanPage: landedOnPlanPage !== undefined && landedOnPlanPage !== null ? landedOnPlanPage : '-',
            noOfRfqCreated: '-',
            planLevel: iContactViewModel.accountType !== undefined && iContactViewModel.accountType !== null ? iContactViewModel.accountType : '-',
            appPage: pageName
          }
        );
      console.log(visitorId.toString() + ' userguiding identify end - supplier');
    }

  }


}
